import React from 'react';
import { SM } from '@zendeskgarden/react-typography';
import { map } from 'lodash'
import { Link } from 'react-router-dom';
import Icon from 'components/Icon/Icon';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import Routes from '../routes';
import {variables} from 'theme/variables';
const {
  custom_navy,
  custom_slate,
} = variables;

export default function CustomBreadcrumbs({omit=[], routeOverride, origin, breadcrumbs, disableDefaults=true, removeRoot}={}) {
  const breadcrumbRoutes = useBreadcrumbs(routeOverride || Routes, {disableDefaults: disableDefaults});
  breadcrumbs = breadcrumbs || breadcrumbRoutes;
  if (origin) {
    breadcrumbs = [origin, ...breadcrumbs]
  }
  return map(breadcrumbs, (d, i, arr) => {
    const last = arr.length -1 === i;
    const link = `${d.key || d.link}${d.suffix || ''}`;
    const title = d.breadcrumb || d.title;
    if ((link === '/' && removeRoot) || omit.indexOf(link) > -1) {
      return null
    }
    return (
      <span key={`${link || i}-${i}`} style={{marginRight: '5px'}}>
        <span style={{marginRight: '5px'}}>
         <Link to={link}><SM  style={{letterSpacing: '1.1px', textTransform: 'uppercase', fontSize: '12px', color: '#76899e'}} bold={last} as="span" link={custom_navy}>{title}</SM></Link> 
        </span>
        {
          last ? null :
          <span>
            <Icon icon={'icon-chevron-right'} color={custom_slate} style={{padding: '0 10px', display: 'inline'}} fontSize={'10px'}/>
          </span>
        } 
      </span>
    )
  })
}





  